var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChipLabelInput',{attrs:{"value":_vm.value,"chip-types":_vm.chipTypes,"chip-tooltip":_vm.companyScopes.length ? 'When sent as a scoped report, the scope label(s) will be inserted here' : '',"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }